<template>
  <div class="tabs" :class="topBannerNavBg==1?'white_bg':'black_bg'">
    <div class="content flex">
    <div class="logo" @click="$router.push('/index')"><img src="../assets/img/logo2.png" alt=""></div>
    <div class="logo_black" @click="$router.push('/index')"><img src="../assets/img/logo_black.png" alt=""></div>
    <div class="flex tab">
      <div :class="id==1?'activite':''" @click="$router.push('/index')">首页</div>
      <div :class="id==2?'activite':''" @click="$router.push('/qudong')">趣动 WillGo</div>
      <div :class="id==3?'activite':''" @click="$router.push('/qyserve')">企业服务</div>
      <div :class="id==4?'activite':''" @click="$router.push('/case')">客户案例</div>
      <div :class="id==5?'activite':''" @click="$router.push('/news')">新闻资讯</div>
      <div :class="id==6?'activite':''" @click="$router.push('/about_us')">联系我们</div>
    </div>
    <div class="download" @click="down_show=!down_show">下载</div>
    <div class="back" @click="goback()">管理后台</div>
    <div class="down_img" v-if="down_show">
      <img src="../assets/img/download_img.png" alt="">
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['id',],

	data () {
		return {
			topBannerNavBg: '',
      down_show:false
		}
	},
	mounted () {
    	window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    },
    methods: {
		// 滚动页面时触发导航变色
	    handleScroll () {
	        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	        // 设置背景颜色的透明度
	        if (scrollTop>0) {
	            this.topBannerNavBg=1 // scrollTop + 多少根据自己的需求设置
	      	} else{
	        	this.topBannerNavBg=0 // 设置回到顶部时，背景颜色为透明
	      	}
          this.down_show=false
	    },
    	// 滚动之前重置
    	beforeDestroy () {
      		window.removeEventListener('scroll', this.handleScroll)
    	},
      goback(){
        window.open('https://organization.qudonghealth.com/')
      }
}
}
</script>

<style scoped>
   .tabs{
     height: 72px;
     width: 100%!important;
     position: fixed;
     top: 0;
     left: 0;
     box-sizing: border-box;
     z-index: 99;
     background: rgba(28, 31, 35, 0.41);
     margin-top: 0!important;
     font-family: PingFangSC-Regular, PingFang SC;
   }
   .flex {
       display: flex;
       align-items: center;
       justify-content: center;
   }
   
   .flex-1,
   .flex1 {
       flex: 1;
   }
   .content{
    width: 1200px;
    margin: 0 auto;
    height: 72px;
    position: relative;
   }
   .logo{
       margin-right: 165px;
   }
   .logo_black{
     cursor:pointer;
    display: none;
    margin-right: 165px;
   }
   .logo_black img{
     width: 106px;
     display: block;
   }
    .logo img{
     cursor:pointer;
     width: 106px;
     display: block;
   }
   .tab{
    font-size: 16px;
    color: #fff;

   }
   .tab div{
     margin-right: 53px;
     position: relative;
     cursor:pointer;
     font-size: 16px;
     font-weight: 400;
     font-family: PingFangSC-Regular, PingFang SC;
     
   }
   .activite::after{
    		content: '';
	      position: absolute;
	      bottom: -23px;
	      left: 50%;
	      margin-left: -5px;
	      width: 10px;
	      height: 2px;
	      background: #FFFFFF;
	      border-radius: 3px;
	      z-index: 1;
        animation: width_up .3s ease-in-out 1 forwards;
        -webkit-animation: width_up .3s ease-in-out 1 forwards;
        transform-origin:center;
   }
    @keyframes width_up {
     0% {
      transform: scale(1);
      opacity: 0;
      
     }
     to {
        transform: scale(2);
        opacity: 1;
     }
   } 
   .download{
    height: 32px;
    width: 88px;
    border-radius: 32px;
    border: 1px solid #fff;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #fff;
    margin-left: 20px;
     cursor:pointer
   }
   .download:hover{
    background-color: rgba(255,255,255,.3);
   }
   .white_bg .download:hover{
    border: 1px solid #fff;
    background-color: rgba(233, 72, 32, .1);
    color: #E94820;
   }
   .back{
      height: 32px;
    width: 88px;
    border-radius: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #fff;
    background-color: #E94820;
    margin-left: 20px;
     cursor:pointer
   }
   .white_bg{
    background: #fff;
   }
   .white_bg .tab{
    color: rgba(17, 17, 17, 1);
   }
   .white_bg .activite{
    color:#E94820 ;
   }
     .white_bg .activite::after{
    		content: '';
	      position: absolute;
	      bottom: -23px;
	      left: 50%;
	      margin-left: -5px;
	      width: 10px;
	      height: 2px;
	      background: #E94820;
	      border-radius: 3px;
	      z-index: 1;
   }
   .white_bg .logo{
    display: none;
   }
    .white_bg .logo_black{
    display: block;
   }
   .white_bg .download{
    border: 1px solid #E94820;
    color: #E94820;
   }
   .black_bg .tab div{
    color: #fff!important;
    font-weight: 400;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
   }
   .down_img{
   
    position: absolute;
    top: 80px;
    right: 107px;
   }
  .down_img img{
    display: block;
    width: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/tabs.vue